exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-footer[data-v-396ffa9e]{text-align:center}[data-v-396ffa9e] .integral-audit-dialog{border-radius:6px}[data-v-396ffa9e] .integral-audit-dialog .el-dialog__header{display:none}[data-v-396ffa9e] .integral-audit-dialog .el-dialog__body{padding:24px 24px 4px}[data-v-396ffa9e] .integral-audit-dialog .el-dialog__footer{padding:8px 24px 20px}", ""]);

// exports
